export interface ApiConfig {
  baseUrl: string;
}

export interface WebConfig {
  baseUrl: string;
}

export interface ObservabilityConfig {
  connectionString: string;
}

export interface AppConfig {
  web: WebConfig;
  api: ApiConfig;
  observability: ObservabilityConfig;
}

// Domains that are branded with a logo
const efesoDomain = "efeso.pinnacle.ceo";
const rtDomain = "rt.pinnacle.ceo";
const gcDomain = "gc.pinnacle.ceo";

// Add more branded domains here
const brandedDomains = new Set([efesoDomain, rtDomain, gcDomain]);

export function isDefaultDomain() {
  return !brandedDomains.has(window.location.hostname);
}

export function isRtDomain() {
  return window.location.hostname === rtDomain;
}

export function isEfesoDomain() {
  return window.location.hostname === efesoDomain;
}

export function isGcDomain() {
  return window.location.hostname === gcDomain;
}

const hostName = window.location.hostname;
const baseUrl =
  hostName === "localhost" ? "http://localhost:3000" : `https://${hostName}`;

const config: AppConfig = {
  web: {
    baseUrl: baseUrl, // || window.ENV_CONFIG.REACT_APP_WEB_BASE_URL || 'http://localhost:3000'
  },
  api: {
    baseUrl:
      window.ENV_CONFIG.REACT_APP_API_BASE_URL ||
      "https://app-api-zje2yzm5mzdky.azurewebsites.net",
    //baseUrl: 'http://localhost:3100'
  },
  observability: {
    connectionString:
      window.ENV_CONFIG.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING || "",
  },
};

export default config;
